/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Fileviewer_Reset_Zoom_TitleInputs */



/**
* | output |
* | --- |
* | "Reset zoom (Ctrl+0)" |
*
* @param {Spaces_Fileviewer_Reset_Zoom_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_fileviewer_reset_zoom_title = /** @type {((inputs?: Spaces_Fileviewer_Reset_Zoom_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Fileviewer_Reset_Zoom_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zoom zurücksetzen (Ctrl+0)")
	return /** @type {LocalizedString} */ ("Reset zoom (Ctrl+0)")
});